import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

import { t } from 'i18next';
import axios from 'axios';

import styles from './JobsDetail.module.css';
import BubbleButton from '../../../Buttons/BubbleButton/BubbleButton';
import Button from '../../../Buttons/Button/Button';
import BasicPopup from '../../../Popups/BasicPopup/BasicPopup';
import FormRichTextField from '../../../FormUI/FormRichTextField/FormRichTextField';
import Yup from '../../../../../utils/yupExtensions';
import { useState } from 'react';
// import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { getCurrencySymbol, getTimeAgo } from '../../../../../utils/formatHelpers';
import { updateApplications, updateFavourites } from '../../../../../app/features/userSlice';
import { ExclusiveJobIcon, SaveBookMark, SaveIcon } from '../../../../../assets/images/icons';
import { useGetEducationLevelsHook, useGetJobCategoriesHook } from '../../../../../utils/utilityHooks';
import { addJobToFavourites, removeJobFromFavourites, sendJobProposal } from '../../../../../services/jobService';

function JobDetailSection({ job, selectedResume, agreeTermsAndCondition, cvPair }) {
    const userToken = useSelector((state) => state.user.token);
    const user = useSelector((state) => state.user.user);
    const dispatch = useDispatch();
    const [formLoading, setFormLoading] = useState(false);

    let city = job.city;
    if (t('general.city.' + city) !== 'general.city.' + city) {
        city = t('general.city.' + city);
    }

    const handleAddToFavourites = () => {
        addJobToFavourites({
            job_id: job.id,
            token: userToken,
        })
            .then(() => {
                dispatch(updateFavourites([...user.favourites, parseInt(job.id, 10)]));
                toast.success(t('job.job_added_to_favorites'));
            })
            .catch((error) => {
                if (error?.response?.data?.error) {
                    toast.error(error.response.data.error);
                }
            });
    };

    const handleRemoveFromFavourites = () => {
        removeJobFromFavourites({
            job_id: job.id,
            token: userToken,
        })
            .then(() => {
                dispatch(updateFavourites(user.favourites.filter((item) => item !== parseInt(job.id, 10))));
                toast.success(t('job.job_removed_from_favorites'));
            })
            .catch((error) => {
                if (error?.response?.data?.error) {
                    toast.error(error.response.data.error);
                }
            });
    };

    let date = '';
    if (job.createdAt) {
        const date_info = getTimeAgo(new Date(job.createdAt));
        date = t('general.UI.posted') + ' ';

        if (date_info.unit_plural === 'second' || date_info.unit_plural === 'seconds') {
            date += t('general.UI.just_now');
        }
        else {
            date += date_info.count + ' ' + t('general.UI.' + date_info.unit_plural) + ' ' + t('general.UI.ago');
        }

    }
    let salary = '';
    let salary_period = t('general.UI.month');

    if (job?.salaryrate) salary_period = t('CompensationAndbenefits.' + job?.salaryrate[0].toUpperCase() + job?.salaryrate.slice(1, job?.salaryrate.length));
    else if (job?.payment_type === 'hourly') salary_period = t('general.UI.hour');

    if (job?.currency && job?.currency !== 'undefined') {
        const currency = getCurrencySymbol(job.currency);
        if (job.salary_low !== job.salary_high) {
            salary = currency + job.salary_low + ' - ' + currency + job.salary_high;
        } else {
            salary = currency + job.salary_low;
        }
    } else {
        const currency = getCurrencySymbol('usd');
        salary = currency + job.salary_low + ' - ' + currency + job.salary_high;
    }

    const desc = job.description;
    const detailUI = (name, value) => (
        <div className={styles.row}>
            <p className={styles.detailTitle}>{name}</p>
            <p className={styles.detailTitleValue}>{value}</p>
        </div>
    );
    const [isSelectCVPopupOpen, setIsSelectCVPopupOpen] = useState(false);
    const [isApplyPopupOpen, setIsApplyPopupOpen] = useState(false);
    const navigate = useNavigate();
    const applyJob = async () => {
        try {
            if (formLoading) {
                return;
            }
            
            setFormLoading(true);

            const selectCVPair = cvPair.filter((e) => e.id === selectedResume);
            if (!selectCVPair.length) {
                toast.error(t('job.no_resume_selected'));
                setFormLoading(false);
                return;
            }

            let cvFilePath;
            let cvRefLetterPath;
            
            if (selectCVPair[0].cv_file instanceof File || selectCVPair[0].cv_ref_letter instanceof File) {
                const formData = new FormData();
                formData.append('token', userToken);
                formData.append('cv_file', selectCVPair[0].cv_file);
                formData.append('cv_ref_letter', selectCVPair[0].cv_ref_letter);
                
                try {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API_URL}job/uploadCV`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }
                    );
                    
                    cvFilePath = response.data.cvFilePath;
                    cvRefLetterPath = response.data.cvRefLetterPath;
                } catch (error) {
                    toast.error(error.response?.data?.error || t('job.file_upload_failed'));
                    setFormLoading(false);
                    return;
                }
            }

            const proposalData = {
                job_id: job.id,
                token: userToken,
                status: "New"
            }
            
            if (selectCVPair.length > 0) {
                proposalData.proposal_cv = selectCVPair[0].cv_file?.path || cvFilePath;
                proposalData.proposal_cover_letter = selectCVPair[0]?.cv_ref_letter?.path || cvRefLetterPath;
            }
            
            toast.promise(sendJobProposal(proposalData), {
                loading: t('general.UI.please_wait'),
                success: <b>{t('general.UI.success')}</b>,
                error: (err) => {
                    return <b>{err.response?.data?.error || t('general.UI.error')}</b>;
                },
            })
            .then((response) => {
                dispatch(updateApplications([...user.applications, parseInt(job.id, 10)]));
                setFormLoading(false);
                setIsApplyPopupOpen(false);
            })
            .catch((error) => {
                setFormLoading(false);
            });
        } catch (error) {
            toast.error(error.message || t('general.UI.something_went_wrong'));
            setFormLoading(false);
        }
    }
    const handleApplyClick = async (e) => {
        e.preventDefault();
        if (user) {
            if (agreeTermsAndCondition) {
                if (user?.verification_status == 'approved') {
                    // setIsApplyPopupOpen(true);
                    applyJob()
                } else {
                    applyJob()
                }
            } else {
                const target = document.querySelector('.formScroll');
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        }
        else {
            navigate('/login');
        }

    };
    const handlePopupClose = () => {
        setIsSelectCVPopupOpen(false);
        setIsApplyPopupOpen(false);
    };
    const educationLevels = useGetEducationLevelsHook();
    const categoryOptions = useGetJobCategoriesHook();
    return (
        <div className={`${styles.container} jobDetail`}>
            <div className={styles.job_card_head_info} style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div className={styles.job_card_head_info_main} >
                    <h5 className={styles.jobTitle}>
                        {job.title}
                        {job.exlusiveJob && <img src={ExclusiveJobIcon} alt="Exclusive Job" />}
                    </h5>
                    {job.exlusiveJob &&
                        <div>
                            <p className={styles.exlusiveJobTitle}>{t("UploadResume.this_is_an_exclusive_job")}</p>
                        </div>
                    }
                </div>
                <div className={styles.applyButtonContainer}>
                    <p className={styles.postedDate} >{date}</p>

                    {user?.account_type === 'jobseeker' && (
                        user?.favourites?.includes(parseInt(job.id, 10)) ? (
                            <div className={styles.bookMarkContainer}>
                                <img
                                    onClick={handleRemoveFromFavourites}
                                    src={SaveBookMark}
                                    className={styles.bookMarkIcon}
                                    style={{ margin: 0 }}
                                    alt="Remove from favorites"
                                />
                            </div>
                        ) : (
                            <img
                                style={{ margin: 0 }}
                                onClick={handleAddToFavourites}
                                src={SaveIcon}
                                className={styles.bookMarkIcon}
                                alt="Add to favorites"
                            />
                        )
                    )}
                    {(user?.account_type !== 'employer' && !user?.applications?.includes(parseInt(job.id, 10))) && (
                        <>
                            {(job.exlusiveJob && user.verification_status !== 'approved') ?
                                <BubbleButton
                                    onClick={() => { navigate('/subscriptions'); }}
                                    dark
                                    headerDarkButton
                                    type="default"
                                    small
                                >
                                    {t('forms.verification.get_verified_to_apply')}
                                </BubbleButton>
                                :
                                <BubbleButton
                                    onClick={handleApplyClick}
                                    dark
                                    headerDarkButton
                                    style={{
                                        // backgroundColor: !user ? '#0464B2' : agreeTermsAndCondition ? '#0464B2' : 'lightGray',
                                        // border: !user ? "1px solid #0464B2" : agreeTermsAndCondition ? "1px solid #0464B2" : "0px solid #0464B2"
                                    }}
                                    type="default"
                                    small
                                >
                                    {t('general.UI.Apply_now')}
                                </BubbleButton>
                            }
                        </>
                    )}
                    {user?.applications?.includes(parseInt(job.id, 10)) && <strong style={{ color: '#34A853' }}>{t('general.UI.applied')}</strong>}

                </div>
            </div>
            <div className={styles.jobBody}>
                <h5 className={styles.jobTitle}>{t("forms.manage_job.subtitle_description")}</h5>
                {desc.trim().replace(/<[^>]*>/g, '').length > 0 && (
                    <div className={styles.job_card_footer}>
                        <div dangerouslySetInnerHTML={{ __html: desc }} className={styles.jobDescription}></div>
                    </div>
                )}
            </div>
            <div className={styles.jobDetail}>
                <h5 className={styles.jobTitle}>{t('forms.manage_job.job_details')}</h5>
                {detailUI(t("forms.manage_job.jobCategory"), categoryOptions.filter((e) => e?.value == job?.category)[0]?.label)}
                {detailUI(t('jobs.salary'), `${salary}/${salary_period}`)}
                {detailUI(t("forms.manage_job.job_type"), t('general.UI.' + job.job_type))}
                {detailUI(t('talents_list.experience'), job.minworkexp + "-" + job.maxworkexp + " " + (job.maxworkexp > 0 ? t('general.UI.years') : t('general.UI.year')))}
                {detailUI(t('job_seeker.education'), educationLevels.filter((e) => e.value == job?.education_level)[0]?.label)}

            </div>

        </div >
    )
}

export default JobDetailSection;